import React from "react";
import PropTypes from "prop-types";
import { FeaturedWrapper } from "./Featured.less";

// Light Blue background , with white border

const Featured = (props) => <div className="FeaturedWrapper">{props.children}</div>;

Featured.propTypes = {
  // bla: PropTypes.string,
};

Featured.defaultProps = {
  // bla: 'test',
};

export default Featured;
